/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
} from "semantic-ui-react";

import Abstract from "./Abstract.js";
import Results from "./Results.js";
// import Comparison from "./Comparison.js";
import overview from "./images/pipeline-1.png";
// import video_website from "./video/video-website.mp4";

import subsection_style from "./style.js";

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});

/* Heads up!
 * HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled
 * components for such things.
 */
const HomepageHeading = ({ mobile }) => (
  <Container fluid>
    {/* <Header
      as="h1"
      content="SinNeR"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "2em" : "4em",
        fontWeight: "normal",
        marginBottom: 0,
        marginTop: mobile ? "0.5em" : "1em",
      }}
    /> */}
    <Header
      as="h1"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "1.5em" : "1.7em",
        fontWeight: "normal",
        marginTop: mobile ? "0.5em" : "1em",
      }}
    >
      <div>
        Uncovering the Disentanglement Capability in Text-to-Image Diffusion Models
      </div>
    </Header>
  </Container>
);

// HomepageHeading.propTypes = {
//   mobile: PropTypes.bool,
// };

// const history = useHistory();

// const handleClick = () => history.push('/post');

// if(handleClick) {
//   db.collection("posts").doc(postId).update({
//     views: increment,
//   })
// }

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
  state = {};

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;
    const { fixed } = this.state;

    return (
      <Media greaterThan="mobile">
        <HomepageHeading />
        {children}
      </Media>
    );
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
};

class MobileContainer extends Component {
  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Media as={Sidebar.Pushable} at="mobile">
        <HomepageHeading mobile />

        {children}
      </Media>
    );
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
};

const ResponsiveContainer = ({ children }) => (
  /* Heads up!
   * For large applications it may not be best option to put all page into these containers at
   * they will be rendered twice for SSR.
   */
  <MediaContextProvider>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </MediaContextProvider>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

const HomepageLayout = ({ mobile }) => (
  <ResponsiveContainer>
    <div>
      <Container text>
        <Grid
          container
          stackable
          verticalAlign="middle"
          columns={3}
          textAlign="center"
          style={{
            fontSize: "1em",
            fontWeight: "normal",
            marginTop: "0.5em"
          }}
        >
          {/* <Grid.Row> */}
          {/* <Grid.Column> */}
          <a href="https://wuqiuche.github.io/" target="_blank" rel="noreferrer">
            Qiucheng Wu<sup>1</sup>
          </a>
          {/* </Grid.Column> */}
          {/* <Grid.Column> */}
          <a href="https://yujianll.github.io" target="_blank" rel="noreferrer">
            Yujian Liu<sup>1</sup>
          </a>
          {/* </Grid.Column> */}
          {/* <Grid.Column> */}
          <a href="https://hdzhao.github.io" target="_blank" rel="noreferrer">
            Handong Zhao<sup>2</sup>
          </a>
          {/* </Grid.Column> */}
          {/* </Grid.Row> */}
        </Grid>
        <Grid
          container
          stackable
          verticalAlign="middle"
          columns={4}
          textAlign="center"
          style={{
            fontSize: "1em",
            fontWeight: "normal",
          }}
        >
          {/* <Grid.Row> */}
          {/* <Grid.Column> */}
          <a
            href="https://dblp.org/pid/04/6453.html"
            target="_blank"
            rel="noreferrer"
          >
            Ajinkya Kale<sup>2</sup>
          </a>
          {/* </Grid.Column> */}
          {/* <Grid.Column> */}
          <a
            href="https://sites.google.com/site/trungbuistanford/"
            target="_blank"
            rel="noreferrer"
          >
            Trung Bui<sup>2</sup>
          </a>
          {/* </Grid.Column> */}
          {/* <Grid.Column> */}
          <a
            href="https://dblp.org/pid/32/1593-1.html"
            target="_blank"
            rel="noreferrer"
          >
            Tong Yu<sup>2</sup>
          </a>
          {/* </Grid.Column> */}
          {/* <Grid.Column> */}
          <a
            href="https://dblp.uni-trier.de/pid/42/1680-1.html"
            target="_blank"
            rel="noreferrer"
          >
            Zhe Lin<sup>2</sup>
          </a>
          {/* </Grid.Column> */}
          {/* </Grid.Row> */}
        </Grid>
        <Grid
          container
          stackable
          verticalAlign="middle"
          columns={2}
          textAlign="center"
          style={{
            fontSize: "1em",
            fontWeight: "normal",
          }}
        >
          {/* <Grid.Row> */}
          {/* <Grid.Column> */}
          <a
            href="https://mitibmwatsonailab.mit.edu/people/yang-zhang/"
            target="_blank"
            rel="noreferrer"
          >
            Yang Zhang<sup>3</sup>
          </a>
          {/* </Grid.Column> */}
          {/* <Grid.Column> */}
          <a
            href="https://code-terminator.github.io/"
            target="_blank"
            rel="noreferrer"
          >
            Shiyu Chang<sup>1</sup>
          </a>
          {/* </Grid.Column> */}
          {/* </Grid.Row> */}
          <div>
            <sup>1</sup> UC, Santa Barbara, 
            <sup>2</sup> Adobe Research,
            <sup>3</sup> MIT-IBM Watson AI Lab
          </div>
          <br />
        </Grid>
      </Container>
      <Grid
        container
        stackable
        verticalAlign="middle"
        columns={2}
        width={10}
        textAlign="center"
        style={{
          fontSize: "1.2em",
          fontWeight: "normal",
          marginTop: "0.5em",
          marginBottom: "0.5em",
        }}
      >
        <Grid.Row>
          <Grid.Column columns={2}>
          <Button primary icon>
              <a
                href="http://arxiv.org/abs/2212.08698"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="book" />
                {" Arxiv"}
              </a>
            </Button>
            <Button primary icon>
              <a
                href="https://github.com/UCSB-NLP-Chang/DiffusionDisentanglement"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="github" />
                {" Code"}
              </a>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Container text>
        <Abstract mobile={mobile} />
        {/* <Header as="h2" textAlign="center" style={subsection_style}>
          Video
        </Header>
        <video
          src={video_website}
          width="100%"
          loop="loop"
          autoplay=""
          controls
        ></video> */}
        <br></br>
        <Header as="h2" textAlign="center" style={subsection_style}>
          Method Overview
        </Header>
        <Image src={overview} style={subsection_style}></Image>
        <p>
          Here, we demonstrate an example of disentangling target attribute "children drawing". 
          In this example, c(0) is the embedding of “A castle”, and c(1) is the embedding of 
          “A children drawing of castle”. The first step (first two rows) is the optimization process 
          that finds the best soft combination of c(0) and c(1), such that the modified image (the second row) 
          changes the attribute without affecting other contents. 
          After this, the learned text embedding can be directly applied to a new image, which leads to the same 
          editing effect (last row).
        </p>
        <Results />
        <Header as="h2" textAlign="center" style={subsection_style}>
        </Header>
        <p style={{ paddingBottom: "0.5em", overflow: "auto" }}>
          <pre>
            <code>

            </code>
          </pre>
        </p>
        <p>
          We are very grateful to the authors of <a href="https://vita-group.github.io/SinNeRF/" target="_blank" rel="noreferrer">
            SinNeRF
          </a> and <a href="http://tancik.com/nerf" target="_blank" rel="noreferrer">
            NeRF
          </a> for sharing the template of the website. 
        </p>
        <br>
        </br>
        <br>
        </br>
        <Header as="h2" textAlign="center" style={subsection_style}>

        </Header>
      </Container>
    </div>
  </ResponsiveContainer>
);

export default HomepageLayout;
